/*
 * @Author: qiyuanchen
 * @Date:   2019-04-16 10:11:11
 */
import { isTBS, isAndroid } from './UA';
import { getAppName } from './appBase';
import { APP_INFO } from './constant'
import TBSDownload from './tbs-download';
import { query } from "./yUtil";

const isDebug = query('isDebug') === '1' && window.location.href.indexOf('sparta') > -1;

const appName = getAppName()
let rmpData = {};

// 点击写入剪切板
export async function refreshRMP(docId) {
  if(appName === 'kb') {
    const appInfo = APP_INFO[appName];
    const freshUrl = appInfo.freshUrl.replace(/{docId}/g, docId); // 替换当前写入剪切板的ID
    window.ClipperForRMP && window.ClipperForRMP.createdClipboardForRefresh(freshUrl);
  } else {
    window.ClipperForRMP && window.ClipperForRMP.refreshRMP(docId, (clip) => {
      isDebug && alert(`已复制剪贴板${clip},
      内容ID:${docId}, 
      内容是否对应${clip === window.ClipperForRMP.listData[docId]}
      内容剪贴板：${window.ClipperForRMP.listData[docId]}`);
      window.isCliped = true;
    });
  }
}

// 初始化写入剪切板, event = 2 资讯； event = 3 视频
export function initRMP(docIdArr = [], event = 2, urlMap = null) {

  const appInfo = APP_INFO['qb']
  const tbsDownload = new TBSDownload(window.tbs, appInfo.downloadUrl, appInfo.pkgName, '')

  return new Promise((resolve, reject) => {

    const classify = (query('classify') || '')
    let initData = {
      docId: '', videoUrl: '', imageUrl: '', title: '',
      classify: event === 3 && (!isNaN(classify) && Number(classify) === 1) ? 1 : 0 };
    const host = window.location.host
    if(host.indexOf('localhost') > -1) {
      resolve({})
      return
    }

    const data = docIdArr.filter(item => !!item).map(item => {
      if (typeof item === 'object') {
        return {...initData, ...item};
      }
      if (typeof item === 'string') {
        return {...initData, docId: item};
      }
      return { docId: item };
    });
    console.log('获取剪贴板', data, urlMap);
    window.ClipperForRMP && window.ClipperForRMP.initRmpNew({
      event,
      type: !urlMap ? 1 : 0,
      data,
      urlMap,
      qbinstall: (isAndroid(window.navigator.userAgent) && isTBS(window.navigator.userAgent) && tbsDownload.isInstalled()) ? 1 : 0,
      env: window.location.host.indexOf('.sparta.html5.qq.com') > -1 ? 'test' : ( window.location.host.indexOf('graykandianshare.html5.qq.com') > -1 ? 'gray' : 'pro') // 测试环境调用rmp的测试接口
    }).then((res) => {
      rmpData = Object.assign(rmpData, res);
      console.log('获取剪贴板结果', res);
      resolve(res);
    }).catch((error) => {
      reject(error);
    });
  });
}

// 获取分享URL的docId
export function getShareURlDocId(url) {
  let docId = '';
  if (url) {
    const pathname = url.substring(0, url.indexOf('?'));
    const pathnameSplit = pathname.split('/');
    docId = pathnameSplit[pathnameSplit.length - 1];
  }
  return docId;
}

// 初始化剪切板
export function initClipboard(docId) {
  isDebug && alert(`初始化剪贴板为 ${docId}`);
  window.ClipperForRMP && window.ClipperForRMP.initClipboard(docId);
}

export function getDocIdRpmData(docId) {
  return rmpData[docId];
}
